import { addVariantToCart } from '@/utils/product';

export default defineNuxtPlugin((nuxtApp) => {
  // This function can be called by outside code to add a variant to the cart
  // Example usage: external A/B testing code, that adds something to the cart
  window.addEventListener('ow-add-to-cart', function (event) {
    addVariantToCart.call(nuxtApp.vueApp, {}, event.detail.variant, event.detail.isCourse);
  });
});
